import usePageActionPermission, {
    PageAction,
} from "pages/notebooks/use-page-action-permission";
import useCurrentPage from "utilities/hooks/domain/notebooks/pages/use-current-page";

export interface UsePageIsViewOnly {
    isViewOnly: boolean;
}

export function usePageIsViewOnly(): UsePageIsViewOnly {
    const { currentPage } = useCurrentPage();

    const { can } = usePageActionPermission(currentPage);
    const viewOnly = !can(PageAction.Edit);

    return {
        isViewOnly: viewOnly,
    };
}
